
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { AppUserClaimsService } from '../services/app-user-claims.service';
import { map } from 'rxjs/operators';
import { AppStateService } from  '../services/app-state.service'
import { ClHeaderComponent } from '@mitel/cloudlink-console-components';
import { UserRoles } from '../constants/constants';


@Injectable()

/*
In the app component, there is a handleUserClaims method that does a lot.
Seems best to wait for that to finish before loading a page.
E.g on a refresh, we want to wait for the policy checks done by handleUserClaims before displaying the integrations
*/
export class ClaimsGuard  {
  constructor(
    private appUserClaimsSvc: AppUserClaimsService, 
    private appStateService: AppStateService,
    private clHeader: ClHeaderComponent
  ) {}

  canActivate(): Observable<boolean> | Promise<boolean> | boolean {
    const claimsHandledFlag = this.appUserClaimsSvc.getClaimsHandledFlag();
    if(claimsHandledFlag){
        return this.checkForGlobalAdmin();

    } else {
      return this.appUserClaimsSvc.claimsHandled.asObservable().pipe(map( flag => {
          return this.checkForGlobalAdmin();
      }));
    }
  }
  /* 
  Currently, there is no reason for a Global_Admin to use the Accounts app unless they are in
  Support Portal Mode.
  Also, only Global_Admins can use the Support Portal Mode.
  This guard may change as we allow Global_Admin to assume role.
  */
  checkForGlobalAdmin(){
    const claims = this.appUserClaimsSvc.getClaims();
    const supportMode = this.appStateService.getSupportPortalMode();
    const featureFlagsMode = this.appStateService.getFeatureFlagsMode();
    let assumed = this.appUserClaimsSvc.isAssumedRole();
    console.debug("Claims guard claims: ", claims);
    console.log("Claims guard supportMode: ", supportMode);
    if(!supportMode && !featureFlagsMode && claims.role !== 'GLOBAL_ADMIN'){
      console.log("Claims guard: ", true);
      return true;
    } else if (supportMode && claims.role === 'GLOBAL_ADMIN' && !assumed){
      console.log("Claims guard: ", true);
      return true;
    } else {
      if(featureFlagsMode && claims.role === UserRoles.GLOBAL_ADMIN && !assumed) {
        return true;
      }
      console.log("Claims guard: ", false);
      this.clHeader.logoutUser();
      return false;
    }
  }
}